export default __webpack_public_path__ + "static/media/fillPatternSemiRight.c95f1540.svg";